<template>
  <div>
    <VToolbar
      height="110px"
      color="white"
      class="toolbar"
      fixed
      app
      scroll-off-screen
    >
      <VToolbarItems
        class="font-weight-bold grow maximize"
        style="flex-basis: 100%;"
      >
        <RouterLink :to="{ name: 'Home' }">
          <img
            src="@/assets/kpplogo.svg"
            class="mt-1"
            style="height: 102px;"
            alt="Körös Print-Pack Kft. Logo"
          >
        </RouterLink>

        <VLayout
          class="mx-3 hidden-sm-and-down"
          align-center
          justify-end
        >
          <span
            v-for="({ name, label, params }, index) in routes"
            :key="name"
            class="font-weight-medium"
            style="font-size: 18px;"
          >
            <RouterLink
              :to="{ name, params }"
              exact
            >
              {{ label }}
            </RouterLink>

            <span
              v-if="index < routes.length - 1"
              class="mx-4"
              style="color: #757575;"
            >
              •
            </span>
          </span>
        </VLayout>

        <VLayout
          class="hidden-md-and-down"
          align-center
          justify-center
        >
          <ContactRow
            :colors="['#42a5f5', '#ff80ab', '#ffea00', '#212121']"
          />
        </VLayout>

        <VLayout
          class="hidden-md-and-up"
          align-center
          justify-end
        >
          <VBtn
            flat
            fab
            large
            color="black"
            @click="showSheet = true"
          >
            <VIcon>menu</VIcon>
          </VBtn>
        </VLayout>
      </VToolbarItems>
    </VToolbar>

    <VBottomSheet
      v-model="showSheet"
      lazy
    >
      <VList>
        <VListTile
          v-for="{ name, label, params } in routes"
          :key="name"
          :to="{ name, params }"
          style="color: #757575;"
        >
          <VListTileTitle
            class="title text-xs-center font-weight-bold"
          >
            {{ label }}
          </VListTileTitle>
        </VListTile>
      </VList>
    </VBottomSheet>
  </div>
</template>

<script>
import ContactRow from '@/components/ContactRow.vue';

export default {
  name: 'TheSiteHeader',
  components: {
    ContactRow,
  },
  data() {
    return {
      routes: [
        {
          name: 'About',
          label: 'Rólunk',
        },
        {
          name: 'Services',
          label: 'Szolgáltatások',
          params: { slug: 'dobozgyartas' },
        },
        {
          name: 'MaterialDelivery',
          label: 'Anyagleadás',
        },
        {
          name: 'Contact',
          label: 'Kapcsolat',
        },
      ],
      showSheet: false,
    };
  },
  watch: {
    '$route.name': function routeNameWatcher() {
      this.showSheet = false;
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #757575;
}

a:hover {
  color: #008179 !important;
}

a:hover .v-list__tile__title {
  color: #008179 !important;
}

.router-link-active {
  color: #008179 !important;
}

a .v-list__tile--active {
  color: #008179 !important;
}

.toolbar >>> .v-toolbar__content {
  justify-content: center;
}
</style>
